<template lang="pug">
.right_box_main
    // 面包屑导航
    .mianbao
        el-breadcrumb(separator-class='el-icon-arrow-right')
            el-breadcrumb-item(:to="{ path: '/griddingindex' }") 网格工作
            el-breadcrumb-item 社区议事协商
            el-breadcrumb-item 数据字典
            el-breadcrumb-item 协商地点
    .card-box
        // 右边卡片
        .card-rb
            .card-4
                el-card(:body-style="{ padding: '16px' }")
                    .fisthang
                        el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini')
                            el-form-item(label='所属社区:')
                                el-cascader(ref='searchArea',:props="optionProps" :options='orgTree.streetCode', v-model='searchAreas', @change='handleChange', style='width:200px',:show-all-levels="false", change-on-select)
                            //- el-form-item(label='详细地址:', style='margin:0 10 0 0;')
                            //-     el-input(v-model='searchlist.detailed', placeholder='请输入', style='width:200px')
                            //- el-form-item(label='状态:', style='margin:0 30 0 0;')
                            //-     el-radio-group(v-model='searchlist.status')
                            //-         el-radio(label='0') 启用
                            //-         el-radio(label='1') 禁用
                            el-form-item
                                el-button(type='primary', @click='searchlistdata') 查询
                            el-form-item
                                el-button(type='info', @click='searchlistReset') 重置
                    .three
                        el-button(type='primary', size='mini', @click="showDialogForm('')") 新增
                    // 表格盒子
                    .table_card
                        el-table(:data='tableData', :header-cell-style="{ background: '#f8fafa' }", border='', align='center')
                            //
                                <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >
                            // <el-table-column type="selection" align="center"></el-table-column>
                            el-table-column(type='index', align='center', label='序号', width='50')
                            el-table-column(align='center', prop='name', label='所属社区')
                                template(scope='scope')
                                    | {{ scope.row.committeeName }} 
                            el-table-column(align='center', prop='detailed', label='详细地址')
                            el-table-column(align='center', prop='status', label='状态', width='100px')
                                template(scope='scope')
                                    el-switch(v-permission="{sign:'sjzd:zkddwh:ztxg'}", v-model='scope.row.status', active-value='0', inactive-value='1', @change='changeStatus(scope.row)')
                            el-table-column(align='center', label='操作', width='300', fixed='right')
                                template(slot-scope='scope')
                                    el-tooltip.item(effect='light', content='查看', placement='top-start') 
                                        button.iconfont.icon-chakan.tabBtn(@click='showDialogFormLook(scope.row.id)')

                                    el-tooltip.item(effect='light', content='编辑', placement='top-start')
                                        button.iconfont.icon-bianji3.tabBtn(@click='showDialogForm(scope.row.id)')
                                    el-tooltip.item(effect='light', content='删除', placement='top-start')
                                        button.iconfont.icon-icon7.tabBtn(@click='showdeletepanduan(scope.row.id)')

                        el-pagination(@size-change='handleSizeChange', @current-change='handleCurrentChange', :current-page='pageConfig.pageNo', :page-sizes='[10, 20, 30, 50]', :page-size='pageConfig.pageSize', layout='total, sizes, prev, pager, next, jumper', :total='pageConfig.total')
    // 弹出框
    el-dialog(:title='dialogTitle', :visible.sync='showadd', width='800px', :before-close='clearadddata')
        el-form(ref='addform', :model='addform', :rules='rules', label-width='110px', size='mini')
            el-form-item(label='所属区域:')
                el-col(:span='8')
                    el-form-item( prop='streetCode' )
                        el-select( v-model="addform.streetCode",@change="orgTreeChange($event,'streetCode')" style='width: 200px;',placeholder="---请选择街道---",:disabled="readyOnly") 
                            el-option( v-for="item in orgTree.streetCode" :key="item.orgId" :label="item.label" :value="item.orgId")

                el-col(:span='8')
                    el-form-item(prop='committeeCode')
                        el-select( v-model="addform.committeeCode",@change="orgTreeChange($event,'committeeCode')" style='width: 200px;',placeholder="---请选择社区---",:disabled="readyOnly") 
                            el-option( v-for="item in orgTree.committeeCode" :key="item.orgId" :label="item.label" :value="item.orgId")
 

                el-col(:span='8')
                    el-form-item(prop='gridCode')
                        el-select( v-model="addform.gridCode",@change="orgTreeChange($event,'gridCode')" style='width: 200px;',placeholder="---请选择网络---",:disabled="readyOnly") 
                            el-option( v-for="item in orgTree.gridCode" :key="item.orgId" :label="item.label" :value="item.orgId")
  
        
            el-form-item(label='详细地址：', prop='detailed')
                el-input(v-model='addform.detailed', style='width: 550px;', @blur='transLocation',:disabled="readyOnly")
            el-form-item(label='地图标识：', prop='lnglat')
                #container(style='width:550px;height:400px;') 
            el-form-item(label='状态：', prop='status')
                el-radio-group(v-model='addform.status',:disabled="readyOnly")
                    el-radio(label='0') 启用
                    el-radio(label='1') 禁用

            el-form-item(label='备注：' )
                el-input(type="textarea" rows="4" v-model='addform.remark', style='width: 550px;',:disabled="readyOnly")

        .boontbtn
            el-button(type='primary', size='small', style='margin: 0 30px', @click='saveadddataClick') 保存
            el-button(type='info', size='small', @click='clearadddata') 取消

</template>

<script>
import { log } from "util"; 
import { OrgTreelist } from "@/api/http";
import AMap from "AMap"; // 引入高德地图
// import ViewMap from "../../../component/mapContainer.vue"
import request from "../../../utils/request.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  // components: { ViewMap},
  data() {
    return {
      optionProps: {
        value: "orgId",
        label: "label"
      },
      dialogTitle: "新增",
      cascaderHolder: "--请选择--", //弹框区域选择的默认提示语
      // 新增弹出层
      showadd: false,
      addform: {},
      rules: {
        selectedOptions: [
          { required: true, message: "请选区域", trigger: "change" }
        ],
        detailed: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选启动状态", trigger: "change" }]
      },
      //省市区三级联动
      searchAreas: [],
      selectedOptions: [],
      // 查询
      searchlist: {
        streetCode: "",
        committeeCode: "",
        gridCode: ""
      },
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      map: null,
      // viewMapTemp: false,
      // mapOptions: {
      //   resizeEnable: true,
      //   zoom: 18
      // }
      readyOnly: false,
      orgTree: {
        streetCode: [],
        committeeCode: [],
        gridCode: []
      },
      //  把汉字当做key获取数组
      orgTree2: {},
      orgTree3: {}
    };
  },
  methods: {
    //条件筛选中，区域选择赋值
    handleChange(value) {
      //   console.log(this.$refs.searchArea.getCheckedNodes()[0].data);
      var areas = this.$refs.searchArea.getCheckedNodes()[0].pathLabels;
      var orgId = this.$refs.searchArea.getCheckedNodes()[0].data.orgId;
      //   this.searchlist.streetCode = areas[0] == "全部" ? "" : areas[0];
      this.searchlist = {
        streetCode: "",
        committeeCode: "",
        gridCode: ""
      };

      if (areas.length == 1) {
        this.searchlist.streetCode = orgId;
      }
      if (areas.length == 2) {
        this.searchlist.committeeCode = orgId;
      }
      if (areas.length == 3) {
        this.searchlist.gridCode = orgId;
      }
    },
    //新增/编辑框中，区域选择赋值
    handleChangeDialog(value) {
      var areas = this.$refs.dialogArea.getCheckedNodes()[0].pathLabels;
      this.addform.province = areas[0];
      if (areas.length > 1) {
        this.addform.city = areas[1];
      }
      if (areas.length > 2) {
        this.addform.area = areas[2];
      }
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchlist = {};
      this.searchAreas = [];
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    orgTreeChange(e, types) {
      //   console.log(e, types);

      if (types == "streetCode") {
        this.orgTree.committeeCode = this.orgTree2[e];
        this.orgTree3 = {};

        this.orgTree2[e].forEach(it => {
          if (it.children && it.children.length) {
            this.orgTree3[it.orgId] = it.children;
          } else {
            this.orgTree3[it.orgId] = [];
          }
        });

        this.orgTree.gridCode = [];
        this.addform.committeeCode = "";
        // this.addform.gridCode = "";
        this.$set(this.addform, "gridCode", "");
      } else if (types == "committeeCode") {
        this.orgTree.gridCode = this.orgTree3[e];
        // this.addform.gridCode = "";
        this.$set(this.addform, "gridCode", "");
      }
    },
    //获取列表数据
    async getPageDatas() {
      let fd = new FormData();
      fd.append("token", token);
      fd.append("pageNo", this.pageConfig.pageNo);
      fd.append("pageSize", this.pageConfig.pageSize);
      let params = JSON.stringify(this.searchlist);
      if (params == "{}") {
        params = '{"status":""}';
      }
      // console.log(params)
      fd.append("findConsultAddress", params);
      var res = await request({
        url: "/admin/consulAddress/info/findConsultAddressList",
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      } else {
        console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    //获取机构树形数据
    async OrgTreelist() {
      let res = await OrgTreelist({});
      //   console.log(res);
      this.orgTree2 = {};
 
      let datas = res.content.filter(it => it.orgType == 1); 

      this.orgTree.streetCode = datas;
      if (datas && datas.length) {
        datas.forEach(it => {
          if (it.children && it.children.length) {
            this.orgTree2[it.orgId] = it.children;
          } else {
            this.orgTree2[it.orgId] = [];
          }
        });
      }
    },
    //改变状态
    async changeStatus(cdata) {
      let fd = new FormData();
      fd.append("token", token);
      let params = JSON.stringify(cdata);
      if (params != "{}") {
        fd.append("consultAddress", params);
      }
      var res = await request({
        url: "/admin/consulAddress/info/insertConsultAddress",
        method: "POST",
        data: fd
      });
      // console.log(res)
      var msg = "状态";
      msg = msg + (cdata.status == "0" ? "启用" : "禁用");
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success"
        });
      } else {
        this.$message({
          message: msg + "失败：" + res.message,
          type: "error"
        });
      }
    },
    showDialogFormLook(id) {
      this.readyOnly = true;
      this.showDialogForm(id);
    },
    async showDialogForm(id) {
      //编辑
      if (id != "") {
        this.dialogTitle = "编辑";
        //获取编辑项的最新数据
        let fd = new FormData();
        fd.append("token", token);
        fd.append("id", id);
        var res = await request({
          url: "/admin/consulAddress/info/findConsultAddressById",
          method: "POST",
          data: fd
        });
        // console.log(res)
        if (res.code == 200) {
          this.addform = res.content;
          this.selectedOptions = []; //保证placeholder能显示
          this.cascaderHolder =
            res.content.province +
            "/" +
            res.content.city +
            "/" +
            res.content.area;
          this.showadd = true;
        } else {
          console.log(res.code + "：" + res.message);
          this.$message({
            message: "编辑项加载异常",
            type: "error"
          });
          this.showadd = false;
        }
      } else {
        this.showadd = true;
        this.dialogTitle = "新增";
        this.cascaderHolder = "--请选择--";
        this.addform = {};
        this.selectedOptions = [];
      }

      // 在这里使用$nextTick初始化地图插件即可
      this.$nextTick(() => {
        // this.viewMapTemp = true
        this.mapInit("container");
      });
    },
    saveadddataClick() {
      this.$refs.addform.validate(valid => {
        if (valid) {
          this.saveadddata();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取新增所有数据发请求
    async saveadddata() {
      let fd = new FormData();
      fd.append("token", token);
      let params = JSON.stringify(this.addform);
      if (params == "{}") {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false;
      }
      fd.append("consultAddress", params);
      console.log(params);
      var res = await request({
        url: "/admin/consulAddress/info/insertConsultAddress",
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success"
        });
        this.showadd = false;
        this.pageConfig.pageNo = 1;
        this.getPageDatas();
      } else {
        console.log(res);
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error"
        });
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false;
    },
    //根据输入地址转换经纬度并标记
    transLocation() {
      var searchKey =
        this.addform.province +
        this.addform.city +
        this.addform.area +
        this.addform.detailed;
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 18
      });
      var that = this;
      AMap.plugin("AMap.Geocoder", function() {
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all"
        });
        var marker = new AMap.Marker();
        geocoder.getLocation(searchKey, function(status, result) {
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            console.log(lnglat);
            that.addform.longitude = lnglat.lng;
            that.addform.latitude = lnglat.lat;
            marker.setPosition(lnglat);
            map.add(marker);
            map.setFitView(marker);
          } else {
            that.$message({
              message: "获取坐标失败，请手动获取",
              type: "error"
            });
          }
        });
      });
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      var map = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18
      });
      if (
        this.addform.longitude != undefined &&
        this.addform.latitude != undefined
      ) {
        var marker = new AMap.Marker({
          position: [this.addform.longitude, this.addform.latitude],
          map: map
        });
        map.setFitView(marker);
      } else {
        AMap.plugin("AMap.Geolocation", function() {
          //异步定位当前
          var geolocation = new AMap.Geolocation();
          map.addControl(geolocation);
        });
      }
      //定义地图坐标点击事件
      var that = this;
      map.on("click", function(e) {
        that.addform.longitude = e.lnglat.getLng();
        that.addform.latitude = e.lnglat.getLat();
      });
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let fd = new FormData();
          fd.append("token", token);
          fd.append("id", id);
          var res = await request({
            url: "/admin/consulAddress/info/deleteConsultAddress",
            method: "POST",
            data: fd
          });
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.showadd = false;
            this.pageConfig.pageNo = 1;
            this.getPageDatas();
          } else {
            console.log(res);
            this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  mounted() {
    // 初始化数据
    this.getPageDatas();
    this.OrgTreelist();
  },
  watch: {
    showadd(val) {
      if (!val) { 
        this.readyOnly = false;
        this.$refs["addform"].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      //   font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
.map-container {
  width: 550px;
  height: 400px;
}
</style>